import {
  CartesianGrid,
  Legend,
  Line,
  LineChart as ReactLineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import styled from '@emotion/styled';
import { RechartsDevtools } from '@recharts/devtools';

interface LineChartProps {
  isAnimationActive?: boolean;
  dataKeys?: string[];
  strokes?: string[];
  types?: ('monotone' | 'linear')[];
  data: Record<string, any>[];
  xAxisDataKey: string;
  aspect?: number;
  showLegend?: boolean;
  tooltipLabel?: string;
}

const LineChart: React.FC<LineChartProps> = ({
  dataKeys,
  strokes,
  types,
  data,
  xAxisDataKey,
  isAnimationActive = true,
  aspect = 1.618,
  showLegend = true,
  tooltipLabel = 'Value',
}) => {
  const chartData = Array.isArray(data) ? data : [];

  return (
    <ResponsiveContainer width='100%' aspect={aspect} maxHeight={500}>
      <ReactLineChart
        // style={{
        //   width: '100%',
        //   maxWidth: '700px',
        //   maxHeight: '70vh',
        //   aspectRatio: 1.618,
        // }}
        responsive
        data={chartData}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid
          strokeDasharray={'5 5'}
          //   verticalFill={['white']}
          //   syncWithTicks={true}
          //   verticalPoints={[0, 100, 200, 300, 400, 500, 600, 700, 800, 900]}
          //   width={20}
          //   x={20}
          fill={'#ffffff'}
          stroke={'#E0E0E0'}
          // vertical={false}
        />

        <XAxis
          dataKey={xAxisDataKey}
          // allowDataOverflow={true}
          // axisLine={false}
          interval={'preserveEnd'}
          // tick={false}
          padding={{ left: 30, right: 30 }}
          // strokeDasharray={'5 5'}
          tickMargin={10}
          tickSize={0}
          stroke='#E0E0E0'
          style={{
            fontSize: '10px',
            fill: '#71748C',
            fontWeight: '700',
          }}
        />
        <YAxis
          width='auto'
          tickSize={0}
          tickMargin={10}
          stroke='#E0E0E00' // I gave this transparent stroke to hide the axis line
          dataKey={dataKeys && dataKeys.length > 0 ? dataKeys[0] : ''}
          style={{
            fontSize: '10px',
            fill: '#71748C',
            fontWeight: '700',
          }}

          // allowDataOverflow={true}
        />
        {/* <Tooltip separator='' /> */}
        <Tooltip
          content={<CustomTooltip tooltipLabel={tooltipLabel} />}
          cursor={{ stroke: '#E5E7EB', strokeWidth: 1, strokeDasharray: '3 3' }}
        />
        {showLegend && <Legend />}
        {dataKeys &&
          dataKeys.map((key, index) => (
            <Line
              dot={false}
              activeDot={{ stroke: '#5B91F5', strokeWidth: 2, r: 6 }}
              key={key}
              type={types && types[index] ? types[index] : 'monotone'}
              dataKey={key}
              stroke={strokes && strokes[index] ? strokes[index] : '#8884d8'}
              isAnimationActive={isAnimationActive}
              strokeWidth={2}
              //   label={{ fill: 'red', fontSize: 20 }}
            />
          ))}
        <RechartsDevtools />
      </ReactLineChart>
    </ResponsiveContainer>
  );
};

const CustomTooltip = ({ active, payload, label, tooltipLabel }: any) => {
  if (active && payload && payload.length) {
    return (
      <TooltipContainer>
        <TooltipLabel>{tooltipLabel || 'Value'}</TooltipLabel>
        <TooltipValue>{payload[0].value}</TooltipValue>
      </TooltipContainer>
    );
  }
  return null;
};

export default LineChart;

const TooltipContainer = styled.div`
  background: white;
  border-radius: 6px;
  padding: 4px 12px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 79px;
`;

const TooltipLabel = styled.div`
  font-size: 10px;
  color: #6b7280;
  font-weight: 400;
  text-align: center;
`;

const TooltipValue = styled.div`
  font-size: 12px;
  color: #000000;
  font-weight: 500;
`;
